import React from 'react';
import { Pencil, Receipt, Trash2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Skeleton } from '../../../components/ui/skeleton';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table';
import { EmptyState, StatusPill } from '../../../components/app';
import { ExpensesTableProps } from '../types';

const day = (d: string) => d.slice(0, 10).split('-').reverse().join('.');

export function ExpensesTable({ expenses, isLoading, onEdit, onDelete, formatMoney }: ExpensesTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Дата</TableHead>
          <TableHead>Заголовок</TableHead>
          <TableHead>Описание</TableHead>
          <TableHead>Плательщик</TableHead>
          <TableHead className="text-right">Сумма</TableHead>
          <TableHead className="w-[1%]">
            <span className="sr-only">Действия</span>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          Array.from({ length: 6 }, (_, i) => (
            <TableRow key={i}>
              {Array.from({ length: 6 }, (__, j) => (
                <TableCell key={j}>
                  <Skeleton className="h-4 w-full max-w-28" />
                </TableCell>
              ))}
            </TableRow>
          ))
        ) : expenses.length === 0 ? (
          <TableRow className="hover:bg-transparent">
            <TableCell colSpan={6}>
              <EmptyState icon={<Receipt />} title="Расходов пока нет" description="Добавьте первый Расход и укажите Плательщика." />
            </TableCell>
          </TableRow>
        ) : (
          expenses.map((expense) => (
            <TableRow key={expense.id}>
              <TableCell className="whitespace-nowrap tabular-nums">{day(expense.date)}</TableCell>
              <TableCell className="font-semibold">{expense.title}</TableCell>
              <TableCell className="max-w-xs truncate text-text-2">{expense.description || '—'}</TableCell>
              <TableCell>
                {expense.payer ? (
                  <StatusPill size="sm" tone={expense.payer.is_company ? 'info' : 'neutral'}>
                    {expense.payer.name}
                  </StatusPill>
                ) : (
                  <span className="text-text-3">—</span>
                )}
              </TableCell>
              <TableCell className="whitespace-nowrap text-right font-semibold tabular-nums">
                {formatMoney(expense.amount)}
              </TableCell>
              <TableCell>
                <div className="flex items-center gap-1">
                  <Button variant="ghost" size="icon-sm" aria-label="Редактировать расход" onClick={() => onEdit(expense)}>
                    <Pencil className="text-text-2" />
                  </Button>
                  <Button variant="ghost" size="icon-sm" aria-label="Удалить расход" onClick={() => onDelete(expense.id)}>
                    <Trash2 className="text-neg" />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
